import { render, staticRenderFns } from "./QuestionsForPrint.vue?vue&type=template&id=b504e0be&"
import script from "./QuestionsForPrint.vue?vue&type=script&lang=js&"
export * from "./QuestionsForPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports